<template>
  <div v-if="!closedBlocks.includes(name)" :class="['ui-info', `ui-info__${color}`, width]">
    <ui-icon :color="iconColor" class="mr-4 mt-4" icon="fas fa-info-circle" />
    <div class="content">
      <slot><div v-html="html" /></slot>
    </div>
    <button
      v-if="(close && name) || closeHandle || closed"
      class="close ml-4 mt-4"
      type="button"
      @click="closeClick"
    >
      <ui-icon icon="fas fa-times-circle" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useColors } from '@/composables';

const props = withDefaults(
  defineProps<{
    html?: string;
    width?: string | boolean;
    name?: string;
    close?: boolean;
    closeHandle?: () => void;
    closed?: boolean;
    color?: string;
  }>(),
  {
    width: 'w100',
    color: 'green',
  },
);

const $colors = useColors();

const closedBlocks = ref<string[]>([]);

const iconColor = computed(() => {
  switch (props.color) {
    case 'green':
      return $colors.graphite;
    case 'red':
      return $colors.red;
    default:
      return $colors.graphite;
  }
});

const getClosedBlocks = () => {
  const value = window.localStorage.getItem('infoBlocksClosed');
  closedBlocks.value = (value && JSON.parse(value)) || [];
};

const closeClick = () => {
  if (props.closeHandle) {
    props.closeHandle();
    return;
  }

  window.localStorage.setItem(
    'infoBlocksClosed',
    JSON.stringify([...new Set([...closedBlocks.value, props.name])]),
  );

  getClosedBlocks();
};

onMounted(() => {
  getClosedBlocks();
});
</script>

<style lang="scss" scoped>
.ui-info {
  display: flex;
  width: 100%;
  background-color: var(--color-green20);
  border-radius: 4px;
  font-size: 13px;
  line-height: 22px;
  padding: 4px 8px;
  align-items: flex-start;
}

.ui-info__red {
  background-color: var(--color-pink);
  color: var(--color-red);
}

.content {
  width: 100%;
  content-visibility: auto !important;
}

.close {
  height: 13px;
  display: flex;
  flex-shrink: 0;
}

.link {
  &:hover {
    text-decoration: underline;
  }
}
</style>
